import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled, keyframes } from '@mui/system';
import { PROMETHEAN_TEXT } from '../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersLoading';
export var generateNumberSizeCss = function generateNumberSizeCss(size) {
  if (typeof size === 'number') {
    return _defineProperty({}, "&-".concat(size), {
      transformOrigin: "".concat(size / 2, "px ").concat(size / 2, "px"),
      fontSize: "".concat(size, "px")
    });
  }
  return {};
};
var rotate = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
export var StyledLoading = styled('i')(function (_ref2) {
  var size = _ref2.size;
  return _defineProperty({
    display: 'inline-block',
    color: PROMETHEAN_TEXT,
    animation: "".concat(rotate, " 7s linear infinite")
  }, "&.".concat(ROOT_PREFIX), _objectSpread({
    '&-x-small': {
      transformOrigin: '8px 8px',
      fontSize: '16px'
    },
    '&-small': {
      transformOrigin: '12px 12px',
      fontSize: '24px'
    },
    '&-medium': {
      transformOrigin: '24px 24px',
      fontSize: '48px'
    },
    '&-large': {
      transformOrigin: '48px 48px',
      fontSize: '96px'
    }
  }, generateNumberSizeCss(size)));
});